import Layer from '@arcgis/core/layers/Layer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../types/AppState';

interface LayerData {
  layer: Layer;
  service: {
    id: number;
    sublayerID?: string;
  };
}

export function useGISLayersOpacity(layers: LayerData[]) {
  const layersOpacity = useSelector(
    (state: AppState) => state.layerOpacity.layers,
  );

  const sublayersOpacity = useSelector(
    (state: AppState) => state.layerOpacity.sublayers,
  );

  useEffect(() => {
    Object.entries(layersOpacity).forEach(([layerId, { opacity }]) => {
      const matchingLayer = layers.find(
        ({ service }) => service.id === Number(layerId),
      );
      if (matchingLayer) {
        matchingLayer.layer.opacity = opacity / 100;
      }
    });
  }, [layersOpacity, layers]);

  useEffect(() => {
    Object.entries(sublayersOpacity).forEach(([sublayerId, { opacity }]) => {
      const matchingLayer = layers.find(
        ({ service }) => service.sublayerID === sublayerId,
      );
      if (matchingLayer) {
        matchingLayer.layer.opacity = opacity / 100;
      }
    });
  }, [sublayersOpacity, layers]);
}
